const loadImg = (src) => new Promise((res) => { const i = new Image(); i.crossOrigin = "anonymous"; i.onload = () => res(i); i.onerror = () => res(null); i.src = src; });

function rr(x, c, X, Y, W, H, R) {
  x.beginPath();
  x.moveTo(X + R, Y); x.arcTo(X + W, Y, X + W, Y + H, R); x.arcTo(X + W, Y + H, X, Y + H, R);
  x.arcTo(X, Y + H, X, Y, R); x.arcTo(X, Y, X + W, Y, R); x.closePath();
  x.fillStyle = c; x.fill();
}

const toneOf = (a = "") => (a === "WAIT" || a.includes("STRANGLE") ? "#FFCC00" : (a.startsWith("BUY PE") || a.includes("SELL CE") || a.includes("SHORT")) ? "#FF3366" : "#00FF66");

export async function composeSnapshot(scene3d, meta) {
  const W = 1080, H = 1440;
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const x = c.getContext("2d");
  x.fillStyle = "#050505"; x.fillRect(0, 0, W, H);
  if (scene3d) x.drawImage(scene3d, 0, 150, W, W);
  const g = x.createLinearGradient(0, 0, 0, H);
  g.addColorStop(0, "rgba(5,5,5,.95)"); g.addColorStop(0.16, "rgba(5,5,5,0)"); g.addColorStop(0.72, "rgba(5,5,5,0)"); g.addColorStop(0.86, "rgba(5,5,5,.97)");
  x.fillStyle = g; x.fillRect(0, 0, W, H);
  const logo = await loadImg("/favicon.svg");
  if (logo) x.drawImage(logo, 60, 48, 72, 72);
  x.font = "900 44px Unbounded, sans-serif"; x.fillStyle = "#fff"; x.fillText("ROBO", 150, 100);
  const rw = x.measureText("ROBO").width;
  x.fillStyle = "#00FF66"; x.fillText("-X", 150 + rw, 100);
  x.font = "500 24px 'JetBrains Mono', monospace"; x.fillStyle = "#718096"; x.textAlign = "right";
  x.fillText(new Date().toLocaleString("en-IN"), W - 60, 96);
  x.textAlign = "left";
  const tone = toneOf(meta.action);
  const y0 = 1040;
  rr(x, "rgba(17,21,28,.92)", 48, y0, W - 96, 340, 28);
  x.fillStyle = tone; x.fillRect(48 + 28, y0, W - 96 - 56, 4);
  x.font = "700 26px 'JetBrains Mono', monospace"; x.fillStyle = tone; x.fillText(meta.action || "", 84, y0 + 64);
  x.font = "700 46px Unbounded, sans-serif"; x.fillStyle = "#fff"; x.fillText(meta.instrument || meta.symbol, 84, y0 + 124);
  x.textAlign = "right"; x.font = "700 96px 'JetBrains Mono', monospace"; x.fillStyle = tone; x.fillText(String(Math.round(meta.score)), W - 84, y0 + 120);
  x.font = "700 20px Manrope, sans-serif"; x.fillStyle = "#718096"; x.fillText("STRENGTH SCORE", W - 84, y0 + 150); x.textAlign = "left";
  (meta.levels || []).slice(0, 4).forEach((l, i) => {
    const bx = 84 + i * 232, by = y0 + 190;
    rr(x, "rgba(255,255,255,.05)", bx, by, 212, 100, 16);
    x.font = "700 18px Manrope, sans-serif"; x.fillStyle = "#718096"; x.fillText(l.k.toUpperCase(), bx + 18, by + 36);
    x.font = "700 30px 'JetBrains Mono', monospace";
    x.fillStyle = l.k === "Stop Loss" ? "#FF3366" : l.k === "Target" ? "#00FF66" : l.k === "Trailing" ? "#00B8FF" : "#fff";
    x.fillText(typeof l.v === "number" ? l.v.toFixed(2) : String(l.v), bx + 18, by + 76);
  });
  x.font = "600 22px Manrope, sans-serif"; x.fillStyle = "#A0AEC0";
  x.fillText(`Join with code ${meta.referral || ""} · Educational, not investment advice`, 60, H - 28);
  return c;
}

export async function shareSnapshot(canvas, meta) {
  const blob = await new Promise((r) => canvas.toBlob(r, "image/png"));
  const file = new File([blob], `robox-${meta.symbol}-${Date.now()}.png`, { type: "image/png" });
  const text = `Robo-X · ${meta.action} ${meta.instrument} · Strength ${Math.round(meta.score)}/100\nJoin with my code ${meta.referral || ""}: ${window.location.origin}/?ref=${meta.referral || ""}`;
  if (navigator.canShare?.({ files: [file] })) {
    try { await navigator.share({ files: [file], text, title: "Robo-X signal" }); return "shared"; }
    catch (e) { if (e.name === "AbortError") return "cancelled"; }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = file.name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
  return "downloaded";
}
